// extracted by mini-css-extract-plugin
export default {"tabMenu":"TabMenu_tabMenu__kilAz","tabs":"TabMenu_tabs__wi79J","tab":"TabMenu_tab__1gwfk","active":"TabMenu_active__1ThP+"};